import { ShoppingCartCheck01Icon } from '@hugeicons/react'

export const DigitalProductStoreWithdrawBottomSheetNoItemsAlert = () => {
  return (
    <div className="bg-gray-200 flex flex-col items-center justify-center py-10 px-10 lg:px-20 mb-10 rounded-lg">
      <ShoppingCartCheck01Icon
        width={56}
        height={56}
        variant="duotone"
        className="mb-6"
      />

      <div className="text-center">
        <h1 className="font-bold mb-5">Nenhum item a retirar</h1>

        <div className="border-t border-dashed border-brand opacity-25 mb-5"></div>

        <div className="text-gray-900 text-sm">
          Você não tem reservas aguardando retirada. Faça novas reservas ou
          confira o histórico
        </div>
      </div>
    </div>
  )
}
